<script setup lang="ts">
/**
 * Root App Component
 * Contains the router-view and global layout elements
 *
 * 根应用组件
 * 包含路由视图和全局布局元素
 */
import { useAuthStore } from '@/stores/authStore'
import { useI18n } from 'vue-i18n'

const authStore = useAuthStore()
const { locale } = useI18n()

/**
 * Toggle language between EN and ZH
 * 在英文和中文之间切换语言
 */
function toggleLanguage() {
  locale.value = locale.value === 'zh' ? 'en' : 'zh'
}
</script>

<template>
  <div class="min-h-screen bg-cream dark:bg-deep-purple transition-colors">
    <!-- Skip to main content link for accessibility -->
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-lg"
    >
      {{ $t('accessibility.skipToMain') }}
    </a>

    <!-- Loading state -->
    <div
      v-if="authStore.isLoading"
      class="fixed inset-0 flex items-center justify-center bg-cream dark:bg-deep-purple"
    >
      <div class="text-center">
        <div
          class="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto"
        />
        <p class="mt-4 text-gray-600 dark:text-gray-300">
          {{ $t('common.loading') }}
        </p>
      </div>
    </div>

    <!-- Main content -->
    <main v-else id="main-content">
      <RouterView />
    </main>

    <!-- Language toggle (floating button) -->
    <button
      @click="toggleLanguage"
      class="fixed bottom-4 right-4 w-12 h-12 bg-white dark:bg-gray-800 rounded-full shadow-lg flex items-center justify-center text-sm font-medium hover:shadow-xl transition-shadow z-40"
      :aria-label="$t('accessibility.toggleLanguage')"
    >
      {{ locale === 'zh' ? 'EN' : '中' }}
    </button>
  </div>
</template>
